import React, { useState } from "react";
import {
  Typography,
  Stack,
  Accordion,
  AccordionDetails,
  Button,
} from "@mui/material";
import CustomAccordionSummary from "styles/customAccordionSummary";
import { ExpandMore } from "@mui/icons-material";
import Chips from "components/Chips";
import {
  ALL,
  DONE,
  IN_FLIGHT,
  BUILD,
  PREPROD,
  PROD,
  REGRESSION,
  UAT,
} from "constants/Constants";

const PipelineStatus = [
  { label: ALL, value: ALL },
  { label: BUILD, value: BUILD },
  { label: "Regression", value: REGRESSION },
  { label: "UAT", value: UAT },
  { label: "Pre-Prod", value: PREPROD },
  { label: "Prod", value: PROD },
].map((v) => ({ ...v, selected: false }));

const Status = [
  { label: ALL, value: ALL },
  { label: "In Flight", value: IN_FLIGHT },
  { label: "Ready", value: "READY" },
  { label: "Done", value: DONE },
].map((v) => ({ ...v, selected: false }));

const Filter = ({
  selectedPipeline,
  setSelectedPipeline,
  selectedStatus,
  setSelectedStatus,
}) => {
  const [expanded, setExpanded] = useState(false);
  const isResetVisible = selectedPipeline !== ALL || selectedStatus !== ALL;

  const handleAccordionChange = () => {
    setExpanded((prev) => !prev);
  };

  const handleResetFilters = () => {
    setSelectedPipeline(ALL);
    setSelectedStatus(ALL);
  };

  return (
    <Accordion
      sx={{ padding: 0, margin: 0 }}
      expanded={expanded}
      onChange={handleAccordionChange}
    >
      <CustomAccordionSummary
        sx={{ padding: 0, margin: 0 }}
        expandIcon={<ExpandMore />}
      >
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{ padding: 0, mb: 0 }}
          px={(theme) => theme.spacing(1)}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Quick Filters:
          </Typography>
          {isResetVisible && (
            <Button onClick={handleResetFilters} color={"chip"}>
              Reset
            </Button>
          )}
          {!expanded && selectedPipeline !== ALL && (
            <Typography variant="body2">
              <span style={{ fontWeight: "bold" }}>By Pipeline Status:</span>{" "}
              {selectedPipeline}
            </Typography>
          )}
          {!expanded && selectedStatus !== ALL && (
            <Typography variant="body2">
              <span style={{ fontWeight: "bold" }}>By Status:</span>{" "}
              {selectedStatus}
            </Typography>
          )}
        </Stack>
      </CustomAccordionSummary>
      <AccordionDetails sx={{ padding: 0, mb: 1 }}>
        <Stack direction="row" spacing={1} sx={{ mb: 1, flexWrap: "wrap" }}>
          <Typography
            variant="subtitle1"
            sx={{ minWidth: 170, fontWeight: "bold" }}
          >
            By Pipeline Status:
          </Typography>
          <Chips
            values={PipelineStatus}
            activeFilter={selectedPipeline}
            selectedFilter={(data) => setSelectedPipeline(data.value)}
          />
        </Stack>

        <Stack direction="row" spacing={1} sx={{ mb: 1, flexWrap: "wrap" }}>
          <Typography
            variant="subtitle1"
            sx={{ minWidth: 170, fontWeight: "bold" }}
          >
            By Status:
          </Typography>
          <Chips
            values={Status}
            activeFilter={selectedStatus}
            selectedFilter={(data) => setSelectedStatus(data.value)}
          />
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default Filter;
